// src/lib/controle-fenetre.js — LA FENÊTRE DE CONTRÔLE, CÔTÉ CLIENT.
//
// RÈGLE (Dimitri 2026-08-21, recalée ici le 2026-08-22) : un ménage se
// contrôle jusqu'à L'HEURE D'ARRIVÉE DU CONTRAT de son jour, PLUS 12 H de
// marge maximum. L'heure du CONTRAT (cfg/guichet), jamais le réel.
//
// ⚠️ HISTOIRE DU BUG (2026-08-22) : ce fichier portait l'ANCIENNE règle des
// 72 h (« miroir » du serveur… jamais recalé quand la règle a changé le
// 21/08). Résultat mesuré : la frise proposait « Contrôler » sur des ménages
// que le serveur refusait en 410 — un bouton qui menait au mur. Un miroir se
// re-désynchronise toujours : la GARDE est désormais un test Jest
// (controle-fenetre.parite.test.js) qui compare CE calcul à celui du serveur
// (lib/controles-handlers._internal) sur une matrice de cas — toute
// divergence future casse la CI.
//
// Le SERVEUR reste l'arbitre (409/410) — ce calcul ne sert qu'à MONTRER,
// griser (avec la raison écrite) ou masquer le bouton « Contrôler ».

const MARGE_FENETRE_H = 12

// Fin de fenêtre en ms UTC. MIROIR EXACT de finFenetreControleMs
// (lib/controles-handlers.js) : heure du contrat convertie « côté large »
// (Paris = UTC+1/+2 → base UTC − 1 h, jamais une fermeture trop tôt), + 12 h.
// `heureContrat` = 'HH:MM' (défaut serveur '16:00' si illisible).
export function finFenetreControleMs(scheduledDateIso, heureContrat) {
  const [y, m, d] = String(scheduledDateIso || '').split('-').map(Number)
  if (!y || !m || !d) return 0
  const hm = /^(\d{1,2}):(\d{2})/.exec(String(heureContrat || '')) || [null, '16', '00']
  const base = Date.UTC(y, m - 1, d, Number(hm[1]), Number(hm[2])) - 3600 * 1000
  return base + MARGE_FENETRE_H * 3600 * 1000
}

/** Le run est-il encore dans la fenêtre (contrat + 12 h) ? */
export function dansFenetreControle(scheduledDateIso, heureContrat, nowMs = Date.now()) {
  return nowMs <= finFenetreControleMs(scheduledDateIso, heureContrat)
}

// « 4h » — l'heure de FIN de fenêtre en heure française. LA borne unique
// (correction Dimitri 2026-08-22) : tout écran qui écrit une échéance de
// contrôle passe par ici — jamais deux chiffres pour une seule règle.
export function heureFinFenetreFR(scheduledDateIso, heureContrat) {
  const fin = finFenetreControleMs(scheduledDateIso, heureContrat)
  if (!fin) return null
  return new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris', hour: 'numeric', minute: '2-digit',
  }).format(new Date(fin)).replace(':', 'h').replace(/^(\d+)h00$/, '$1h')
}

// « Le contrôle devait être fait avant 4h. » — LA RAISON ÉCRITE d'un bouton
// grisé (règle : un bouton mort dit pourquoi).
export function raisonFenetrePassee(scheduledDateIso, heureContrat) {
  const h = heureFinFenetreFR(scheduledDateIso, heureContrat)
  if (!h) return 'Fenêtre de contrôle passée.'
  return `Le contrôle devait être fait avant ${h}.`
}
